export const appArrowDownIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.78205 7.86295L12.1371 12.977L17.4921 7.86296L19.1371 9.43738L12.1371 16.1371L5.13705 9.43738L6.78205 7.86295Z" fill="#4F4F4F"/></svg>`,
    name: 'arrow-down'
};